module.exports = __webpack_public_path__ + "img/avatar.b0c4c4bf.jpg";